import { Polygon, SimpleGeometry } from "ol/geom";
import { OpenLayersGeometryWithArea } from "../../geom/area";
import { IMapTopologyGeometry } from "./types";
import { ol_geom } from "@omnia/exports/openlayers";
import { isFunction } from "@omnia/shared/utils/utils";

/** @internal */
export class JstsGeom implements IMapTopologyGeometry {

    constructor(private jsts: jsts.geom.Geometry, private ol: ol_geom.Geometry, private wkt: string) {
    }

    getArea(): number {

        const { ol, jsts } = this

        if (jsts) return jsts.getArea();

        if (hasGetArea(ol)) {
            return ol.getArea()
        }

        return 0;

    }

    getLength(): number {

        const { ol, jsts } = this

        if (jsts) return jsts.getLength()

        if (hasGetLength(ol)) {
            return ol.getLength()
        }

        return 0;

    }


    getDimension(): number {

        if (this.jsts) return this.jsts.getDimension();

        switch (this.getType()) {

            case "Point":
            case "MultiPoint":
                return 0;

            case "LineString":
            case "MultiLineString":
                return 1;

            case "Polygon":
            case "MultiPolygon":
                return 2;

        }

        return null;

    }

    getJstsGeometry(): jsts.geom.Geometry {
        return this.jsts;
    }

    getOpenLayersGeometryWithArea(): OpenLayersGeometryWithArea {
        const { ol } = this
        return ol?.["getArea"] ? ol as OpenLayersGeometryWithArea : undefined
    }

    getOpenLayersGeometry(): ol_geom.Geometry {
        return this.ol;
    }

    getOpenLayersPolygon(): ol_geom.Polygon {
        return (this.ol instanceof ol_geom.Polygon) ? this.ol : undefined
    }

    getWKT(): string {
        return this.wkt;
    }

    isEmpty() {

        const { jsts, ol } = this

        if (jsts) {
            return jsts.isEmpty()
        }

        if (!ol) {
            return true
        }

        return false

    }
    isValid(): boolean {

        if (this.jsts) {
            return this.jsts.isValid()
        }

        return this.isEmpty()

    }

    getType(): string {

        if (this.jsts) {
            return this.jsts.getGeometryType();
        }

        if (this.ol) {
            return (<any>this.ol).getType();
        }

    }


}


function hasGetArea(ol: any): ol is { getArea: () => number } {
    if (ol && isFunction(ol["getArea"])) {
        return true
    }
}

function hasGetLength(ol: any): ol is { getLength: () => number } {
    if (ol && isFunction(ol["getLength"])) {
        return true
    }
}